import { render, staticRenderFns } from "./DbSyncConfigForm.vue?vue&type=template&id=19ef6f98&"
import script from "./DbSyncConfigForm.vue?vue&type=script&lang=ts&"
export * from "./DbSyncConfigForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports